<template>
  <div>
    <div
      klickbox-edit-item="general"
      :klickbox-edit-label="$t('edit.canvas.general_styles')">
      <div class="kbx-content">
        <title-preview></title-preview>
        <description></description>
      </div>
    </div>
  </div>
</template>

<script>
import TitlePreview from './../Title';
import Description from './../Description';

export default {
  components: {
    TitlePreview,
    Description,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?21b95a56
 **/